export const ARRANGE_CHANNEL_SEQUENCE = "ARRANGE_CHANNEL_SEQUENCE";
export const ARRANGE_CHANNEL_SEQUENCE_SUCCESS = "ARRANGE_CHANNEL_SEQUENCE_SUCCESS";
export const ARRANGE_CHANNEL_SEQUENCE_FAIL = "ARRANGE_CHANNEL_SEQUENCE_FAIL";
export const CLEAR_ARRANGE_CHANNEL_SEQUENCE = "CLEAR_ARRANGE_CHANNEL_SEQUENCE"